import React from "react";
const testimonials = [
  {
    name: "Rahul Sharma",
    location: "Chennai, India",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
    text: "Amazing quality products and fast delivery. Highly recommended!",
    rating: 5,
  },
  {
    name: "Priya Patel",
    location: "Chennai, India",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "Customer service was helpful. Loved it shopping experience.",
    rating: 5,
  },
  {
    name: "Priya Patel",
    location: "Chennai, India",
    image: "https://randomuser.me/api/portraits/women/45.jpg",
    text: "Customer service was helpful. Loved it shopping experience.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <div className="testimonial-section">
      <h2>Loved by Senthan Families</h2>
      <div className="testimonial-sub">
        ⭐ 4.9/5 from 1200+ parents &nbsp;&nbsp; 👨‍👩‍👧 Loved by 10,000+ families
      </div>
      <div className="testimonial-container">
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>            
            <div className="quote">❝</div>
            <img src={item.image} alt="" className="avatar" />
            <h3>{item.name}</h3>
            <p className="location">📍 {item.location}</p>
            <p className="verified">✔ Verified Buyer</p>
            <p className="review">"{item.text}"</p>
            <div className="stars">
              {"⭐".repeat(item.rating)} <span>5.0</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}